"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../device"));
const User = __importStar(require("../../../../../user"));
const openapi_1 = require("../../../../openapi");
const UserStats = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.User.Spec';
/*
 * `routes/v2/api/user/router.js`: `PublicRouteGuard` on every route, so no
 * guard answers 401/403. Four controllers read the session user themselves
 * (`Security.OptionalUser`: the credential is published as optional); the
 * goals route reads `userId` from the body and checks no session at all.
 */
const noUser = (kind) => 'Credential: the router is public, but the controller reads the session user. ' +
    `An anonymous session or an SSO token without a user makes \`getUser()\` throw \`NOT_ALLOWED\`, answered as a ${kind} 500; ` +
    'only a CPort token without a user gets the 401 `NotAuthenticatedError`.';
const NO_USER_TYPED = noUser('typed');
const NO_USER_V1 = noUser('v1');
// Query structs intentionally have no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const LoyaltyStatusQuery = effect_1.Schema.Struct({
    adminUserId: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'User to read instead of the caller; admins only',
    }),
    from: effect_1.Schema.propertySignature(effect_1.Schema.Date).annotations({ description: 'Range start (ISO date-time)' }),
    to: effect_1.Schema.propertySignature(effect_1.Schema.Date).annotations({ description: 'Range end (ISO date-time)' }),
});
const StatsQuery = effect_1.Schema.Struct({
    aggregation: effect_1.Schema.propertySignature(User.StatsAggregationKind).annotations({
        description: 'Aggregation period. Only `week` and `year` are implemented; `month` answers 500.',
    }),
    year: effect_1.Schema.propertySignature(effect_1.Schema.String).annotations({ description: 'Year of the statistics' }),
    month: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'Accepted but unused',
    }),
    week: effect_1.Schema.optionalWith(effect_1.Schema.String, { exact: true }).annotations({
        description: 'ISO week number; required for `week`',
    }),
    weekStart: effect_1.Schema.optionalWith(effect_1.Schema.Literal('monday', 'sunday'), { exact: true }).annotations({
        description: 'First day of the week (default monday)',
    }),
});
const loyaltyStatus = platform_1.HttpApiEndpoint.get('listUserLoyaltyProgramsStatus') `/list/loyalty-programs-status`
    .setUrlParams(LoyaltyStatusQuery)
    .addSuccess(openapi_1.Response.Success(UserStats.LoyaltyProgramStatusList).annotations({
    description: 'Loyalty program statuses in the range',
}))
    .addError(openapi_1.Error.NotAuthenticated)
    .addError(openapi_1.Error.NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'List Loyalty Program Statuses')
    .annotate(platform_1.OpenApi.Description, 'Returns the loyalty program statuses of the session user updated between `from` and `to`. ' +
    'Admins may pass `adminUserId` to read another user; other callers get 401 `NotAuthorizedError`. ' +
    NO_USER_TYPED)
    .pipe(openapi_1.Security.OptionalUser, openapi_1.Error.withLegacyV2PublicErrors);
const createDeviceDispense = platform_1.HttpApiEndpoint.post('createUserDispensingHistory') `/stats/create/device`
    .setPayload(UserStats.DeviceDispenseBody)
    .addSuccess(openapi_1.Response.Success(Device.History.UserDispense).annotations({
    description: 'The recorded dispense',
}), { status: 201 })
    .addError(openapi_1.Error.LegacyValidation)
    .addError(openapi_1.Error.NotAuthenticated)
    .annotate(platform_1.OpenApi.Title, 'Record Device Dispense')
    .annotate(platform_1.OpenApi.Description, 'Records a drink dispensed from a device for the session user and answers 201. ' +
    'The id is `<userId>-<timestamp>`; a clash answers 422 in the legacy validation format. ' +
    'The `userId` of the body is required by the decoder but replaced with the session user. ' +
    NO_USER_V1)
    .pipe(openapi_1.Security.OptionalUser, openapi_1.Error.withLegacyV2PublicErrors);
const createManualDispense = platform_1.HttpApiEndpoint.post('createUserManualDispensingHistory') `/stats/create`
    .setPayload(UserStats.ManualDispenseBody)
    .addSuccess(openapi_1.Response.Success(User.UserManualDispensingHistoryItem).annotations({
    description: 'The recorded dispense',
}), { status: 201 })
    .addError(openapi_1.Error.LegacyValidation)
    .addError(openapi_1.Error.NotAuthenticated)
    .annotate(platform_1.OpenApi.Title, 'Record Manual Dispense')
    .annotate(platform_1.OpenApi.Description, 'Records a drink the session user entered by hand, tagged with the client application of the session, and answers 201. ' +
    'The id is `<userId>-<timestamp>`; a clash answers 422 in the legacy validation format. ' +
    NO_USER_V1)
    .pipe(openapi_1.Security.OptionalUser, openapi_1.Error.withLegacyV2PublicErrors);
const addGoals = platform_1.HttpApiEndpoint.post('addUserGoals') `/goals`
    .setPayload(UserStats.GoalsBody)
    .addSuccess(openapi_1.Response.Success(UserStats.UserWithGoals).annotations({
    description: 'The updated user',
}))
    .annotate(platform_1.OpenApi.Title, 'Set User Goals')
    .annotate(platform_1.OpenApi.Description, 'Sets the daily hydration goal of the user given by `userId` in the body and answers the stored user record. ' +
    'No credential is checked and `userId` is not compared with any session: the route acts on whichever user the body names. ' +
    'Known runtime quirk: a missing field or an unknown user answers 500 `InternalServerError`, not 400/404.')
    .pipe(openapi_1.Security.Public, openapi_1.Error.withLegacyV2PublicErrors);
const stats = platform_1.HttpApiEndpoint.get('getUserHydrationStats') `/stats`
    .setUrlParams(StatsQuery)
    .addSuccess(openapi_1.Response.Success(UserStats.HydrationStats).annotations({
    description: 'Hydration statistics',
}))
    .addError(openapi_1.Error.NotAuthenticated)
    .annotate(platform_1.OpenApi.Title, 'Get Hydration Statistics')
    .annotate(platform_1.OpenApi.Description, 'Returns the hydration of the session user per day of a week (`aggregation=week`, with `year` and `week`) or per month of a year (`aggregation=year`). ' +
    'Device and manual dispenses are summed. Known runtime quirk: a missing `week` or an unsupported aggregation answers 500 `InternalServerError`. ' +
    NO_USER_TYPED)
    .pipe(openapi_1.Security.OptionalUser, openapi_1.Error.withLegacyV2PublicErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.user')
    .add(loyaltyStatus)
    .add(createDeviceDispense)
    .add(createManualDispense)
    .add(addGoals)
    .add(stats)
    .prefix('/user')
    .annotate(platform_1.OpenApi.Title, 'User')
    .annotate(platform_1.OpenApi.Description, 'Dispensing history, hydration statistics and loyalty of the session user, and hydration goals of any user. ' +
    'The router is `PublicRouteGuard`: no route enforces a credential, see each operation.')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.User));
//# sourceMappingURL=spec.js.map